import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as InfoIcon } from '../../../../assets/info.svg';
import * as Styled from './EmptyState.styles';

interface EmptyStateInterface {
  visible: boolean;
  children: ReactNode;
}

const EmptyState = ({ visible, children }: EmptyStateInterface) => {
  const { t } = useTranslation();

  if (visible) {
    return (
      <Styled.Container>
        <InfoIcon />
        <Styled.TextContainer>
          <Styled.Title>{t('certificate.fieldIsEmptyDescription')}</Styled.Title>
          <Styled.Subtitle>{t('certificate.fieldIsEmpty')}</Styled.Subtitle>
        </Styled.TextContainer>
      </Styled.Container>
    );
  }

  return <>{children}</>;
};

export default EmptyState;
